import apiClient from "./axiosConfig";

export const login = async (params) => {
  return apiClient({
    method: "post",
    url: "/auth/admin/",
    data: params,
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));
};

export const refreshToken = async (refreshToken) => {
  return apiClient({
    method: "post",
    url: "/auth/admin/",
    data: { refresh_token: refreshToken },
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));
};

export const getUserBasicDetails = async () => {
  return apiClient({
    method: "get",
    url: "/users/basic-details/",
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));
};
